import React from 'react'
import NotesUnsavedChangesModal from '@components/pages/Notes/Modals/NotesUnsavedChangesModal.component'
import type { PendingLeaveAction } from './notesFeature.types'

type NotesPendingLeaveModalProps = {
  pendingLeave: PendingLeaveAction | null
  onDismiss: () => void
  onDiscard: () => void
  onSave: () => void
}

const getPendingLeaveMessage = (pendingLeave: PendingLeaveAction): string => {
  switch (pendingLeave.kind) {
    case 'link':
      return 'Please save your changes before opening the link, or your edits will be lost.'
    case 'overlay':
      return 'Please save your changes before closing notes, or your edits will be lost.'
    case 'overlayListHome':
      return 'Please save your changes before returning to the notes list, or your edits will be lost.'
    default:
      return 'Please save your changes before leaving.'
  }
}

const NotesPendingLeaveModal: React.FC<NotesPendingLeaveModalProps> = ({
  pendingLeave,
  onDismiss,
  onDiscard,
  onSave,
}): React.ReactElement => (
  <NotesUnsavedChangesModal
    show={pendingLeave != null}
    leaveMessage={
      pendingLeave
        ? getPendingLeaveMessage(pendingLeave)
        : 'Please save your changes before leaving.'
    }
    onDismiss={onDismiss}
    onDiscard={onDiscard}
    onSave={onSave}
  />
)

export default NotesPendingLeaveModal
